module.exports = __webpack_public_path__ + "img/kjjh_gallery7.19f50a72.jpg";